'use client'

import { useSession, signIn, signOut } from 'next-auth/react'
import { useCallback } from 'react'

export function useAuth() {
  const { data: session, status } = useSession()

  const login = useCallback(async (provider?: string) => {
    const result = await signIn(provider, {
      callbackUrl: '/',
      redirect: false
    })

    if (result?.error) {
      console.error('Login error:', result.error)
      throw new Error(result.error)
    }

    return result
  }, [])

  const logout = useCallback(async () => {
    await signOut({ callbackUrl: '/', redirect: true })
  }, [])

  const getAccessToken = useCallback(async (): Promise<string | null> => {
    if (session?.accessToken) {
      return session.accessToken
    }
    return null
  }, [session])

  return {
    user: session?.user || null,
    accessToken: session?.accessToken || null,
    provider: session?.provider || null,
    isLoading: status === 'loading',
    isAuthenticated: status === 'authenticated',
    login,
    logout,
    getAccessToken,
  }
}
